import { connect } from 'react-redux';

// Components
import ModalServicesList from './ModalServicesList';

// Selectors
import {
  getApptMenuType,
  getIndividualTotalPrice,
  getServicePoint,
  getIndividualServicesCount
} from 'store/reducers/appointment/selectors';
import { getPolicyProperty } from 'store/reducers/dealerSettings/selectors';
import { getAppName } from 'store/reducers/userInteractions/selectors';

const mapStateToProps = state => {
  const getTellusmoreSvcId = getPolicyProperty(state);
  return {
    apptServicePoint: getServicePoint(state),
    apptMenuType: getApptMenuType(state),
    individualTotalPrice: getIndividualTotalPrice(state),
    tellusmoreSvcId: getTellusmoreSvcId('tellusmoreSvcId'),
    servicesCount: getIndividualServicesCount(state),
    appName: getAppName(state)
  };
};

export default connect(
  mapStateToProps,
  {}
)(ModalServicesList);



// WEBPACK FOOTER //
// ./src/components/molecules/ModalServicesList/ModalServicesListContainer.js